export default "__VITE_ASSET__CY5$NhZl__"